import styles from '@ui/components/Link/Link.module.scss';
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Link = forwardRef(
  (
    { children, className = null, rel = null, target = '_self', to, ...props },
    ref,
  ) => (
    <a
      className={classNames(styles.link, className)}
      href={to}
      ref={ref}
      rel={rel}
      target={target}
      {...props}
    >
      {children}
    </a>
  ),
);

Link.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_parent', '_self', '_top']),
  to: PropTypes.string,
};

Link.displayName = 'Link';

export default Link;
